import React from 'react'
import QuizContext from '../../QuizContext'
import { useFooterState } from '../../hooks'

const FooterView = props => {
  const footer = useFooterState()

  return props.children(footer) || null
}

FooterView.displayName = 'QuizFooterView'

export default FooterView
